import { ref, onUnmounted } from 'vue';

export const useCountdown = (initialTime = 60) => {
  const timeLeft = ref<number>(initialTime);
  const isCounting = ref<boolean>(false);
  let timer: number | undefined;

  const startCountdown = () => {
    if (isCounting.value) return;
    isCounting.value = true;
    timer = window.setInterval(() => {
      if (timeLeft.value > 0) {
        timeLeft.value--;
      } else {
        clearInterval(timer);
        isCounting.value = false;
      }
    }, 1000);
  };

  const resetTime = () => {
    clearInterval(timer);
    isCounting.value = false;
    timeLeft.value = initialTime;
  };

  onUnmounted(() => {
    if (timer) {
      clearInterval(timer);
    }
  });

  return {
    timeLeft,
    isCounting,
    startCountdown,
    resetTime
  };
};
